import { render, staticRenderFns } from "./SpeechDetail.vue?vue&type=template&id=ffc6f360&scoped=true&"
import script from "./SpeechDetail.vue?vue&type=script&lang=js&"
export * from "./SpeechDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpeechDetail.vue?vue&type=style&index=0&id=ffc6f360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc6f360",
  null
  
)

export default component.exports